<template>
	<div class="modal_info">
		<div class="fe-btn-translation" @click="$root.$emit('open_modal_translation', 'Payment Error', arrayTranslations)" v-if="globalTranslate">OPEN TRANSLATION</div>

		<div class="header-submodal">
			<div class="image"><img src="/build/icons/payment-problem-icn.svg"></div>
			<div class="title">{{ $t('subscription.error_payment_large') }}</div>
		</div>
		<div class="description-modal">{{ $t('subscription.grace_period_desc') }}</div>

		<div class="button-actions">
			<button class="btn-blue-tbf button-action" @click="changeModal">
				{{ $t('subscription.change_method') }}
			</button>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data() {
			return {
				loaded: false,
				nameItem: '',
				arrayTranslations: [
					'subscription.error_payment_large',
					'subscription.grace_period_desc',
					'subscription.change_method'
				]
			};
		},
		props: {
			type: String,
		},
		mounted() {
			
		},
		methods: {
			changeModal(){
				this.$root.$emit('change_modal', 'change_subscription');
			},
		}
	};
</script>